import { connectWithScope } from '#packages/apilib';
import { Button } from '@wix/wix-base-ui';
import { ShowSmall } from '@wix/wix-ui-icons-common/classic-editor';
import React from 'react';
import * as baseUI from '#packages/baseUI';
import { InfoIcon, TextLabel, Tooltip } from '@wix/wix-base-ui';
import { cx } from '#packages/util';
import { translate } from '#packages/i18n';
import experiment from 'experiment';
import * as symbols from '@wix/santa-editor-symbols';

import { HiddenElementsScope } from '../../hiddenElementsScope';

import type { HiddenElement } from '../../hiddenElementsTypes';

import styles from './hiddenElementThumbnail.scss';

const isRedesignExperimentOpen =
  experiment.getValue('se_leftPanelHiddenMobileElementsRedesign') === 'B' ||
  experiment.getValue('se_leftPanelHiddenMobileElementsRedesign') === 'C';

interface HiddenElementThumbnailOwnProps {
  element: HiddenElement;
  onMouseEnter: (element: HiddenElement) => void;
  onMouseLeave: (element: HiddenElement) => void;
  onClick: (element: HiddenElement) => void;
}

interface HiddenElementThumbnailProps extends HiddenElementThumbnailOwnProps {}

const HiddenElementThumbnail: React.FC<HiddenElementThumbnailProps> = ({
  element,

  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  const ShowButton = () => (
    <Tooltip content="mobile_hidden_items_show_tooltip">
      {isRedesignExperimentOpen && (
        <Button
          className={cx([
            'btn-sm',
            'btn-confirm-secondary',
            styles.showButtonWds,
          ])}
          prefixIcon={<ShowSmall />}
        >
          {translate('mobile_hidden_items_show_button')}
        </Button>
      )}
      {!isRedesignExperimentOpen && (
        <div className={styles.showButton}>
          <baseUI.symbol name="showComp" className={styles.showSymbol} />{' '}
          <span className={styles.text}>
            {translate('mobile_hidden_items_show_button')}
          </span>
        </div>
      )}
    </Tooltip>
  );

  return (
    <div
      data-hook="hidden-element-thumbnail"
      onClick={() => onClick(element)}
      onMouseEnter={() => onMouseEnter(element)}
      onMouseLeave={() => onMouseLeave(element)}
      className={cx(styles.hiddenElementThumbnail, {
        [styles.isInteraction]: element.isInteraction,
        [styles.withRedesignExperiment]: isRedesignExperimentOpen,
      })}
    >
      {element.icon && (
        <div
          className={styles.icon}
          style={{
            ...element.icon.css,
            backgroundImage: `url(${element.icon.src})`,
          }}
        >
          {element.icon.svgName && (
            <symbols.symbol key="hiddenItemIcon" name={element.icon.svgName} />
          )}
        </div>
      )}

      <div className={styles.label}>
        <span>
          <TextLabel
            shouldTranslate={false}
            value={element.label}
            automationId="text-label"
          />

          {element.isInteraction && (
            <>
              <symbols.symbol
                key="hoverInteractionIcon"
                name="hoverInteraction"
                className={styles.hoverInteractionIcon}
              />
              <div>
                <TextLabel
                  type="T12"
                  className={styles.hoverInteractionLabel}
                  value="mobile_hidden_items_section_title_interactions"
                />
              </div>
            </>
          )}
        </span>
      </div>

      {element.isEssential ? (
        <InfoIcon
          tooltipClassName="essential"
          error={true}
          small={true}
          text={element.essentialText}
          automationId="essential-info"
          shouldTranslate={false}
        />
      ) : null}

      <ShowButton />
    </div>
  );
};

export default connectWithScope(
  () => HiddenElementsScope,
  HiddenElementThumbnail,
  null,
  null,
);
